module.exports = __webpack_public_path__ + "static/media/undraw_female_3.008c4201.svg";